import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import type { RadioGroupProps } from "./RadioGroup.types";

const RadioGroupValueContext = createContext<any>(null);
const RadioGroupNameContext = createContext<string | null>(null);
const RadioGroupActionContext = createContext<undefined | ((val: any) => void)>(undefined);

export const RadioGroupProvider = <T,>({
  value,
  onChangeValue,
  children,
  name,
}: PropsWithChildren<Pick<RadioGroupProps<T>, "value" | "onChangeValue">> & {
  name: string | null;
}) => {
  return (
    <RadioGroupActionContext.Provider value={onChangeValue}>
      <RadioGroupNameContext.Provider value={name}>
        <RadioGroupValueContext.Provider value={value}>{children}</RadioGroupValueContext.Provider>
      </RadioGroupNameContext.Provider>
    </RadioGroupActionContext.Provider>
  );
};

export const useRadioGroupValue = () => useContext(RadioGroupValueContext);
export const useRadioGroupAction = () => useContext(RadioGroupActionContext);
export const useRadioGroupName = () => useContext(RadioGroupNameContext);
